<template lang="pug">
div.pad
  el-row.usar-dados-cadastrante(v-if="showUsarDadosCadastrante()")
    el-col
      el-checkbox(
        v-model="dadosCadastrante"
        label="Usar dados do cadastrante",
        @change="usarDadosCadastrante"
      )
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.cpf.validacao')", v-slot="{ errors }", :name="nomeAba + '/CPF do interessado'")
        app-label(:label="camposValidacao('interessado.pessoaFisica.cpf.label')")
        el-input.input(
          name='CPF',
          v-model="cadastroFormulario.interessado.pessoa.pessoaFisica.cpf",
          v-mask="'###.###.###-##'",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.nome.validacao')", v-slot="{ errors }", :name="nomeAba + '/Nome do interessado'")
        app-label(:label="camposValidacao('interessado.pessoaFisica.nome.label')")
        el-input.input(
          name='Nome',
          maxlength="300",
          v-model="cadastroFormulario.interessado.pessoa.pessoaFisica.nome",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(:gutter="30")
    el-col(:span="8")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.apelido.validacao')" v-slot="{ errors }", :name="nomeAba + '/Apelido do interessado'")
        app-label(:label="camposValidacao('interessado.pessoaFisica.apelido.label')" :required="camposValidacao('interessado.pessoaFisica.apelido.obrigatorio')")
        el-input.input(
          type="text"
          maxlength="300"
          name='apelido'
          v-model="cadastroFormulario.interessado.pessoa.pessoaFisica.apelido"
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.rg.validacao')", v-slot="{ errors }", :name="nomeAba + '/RG do interessado'")
        app-label(:label="camposValidacao('interessado.pessoaFisica.rg.label')", :required="camposValidacao('interessado.pessoaFisica.rg.obrigatorio')")
        el-input.input(
          name='RG',
          maxlength="30",
          v-model="cadastroFormulario.interessado.pessoa.pessoaFisica.rg",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.orgaoExpedidor.validacao')", v-slot="{ errors }", :name="nomeAba + '/Órgão Expedidor do interessado'")
        app-label(:label="camposValidacao('interessado.pessoaFisica.orgaoExpedidor.label')", :required="camposValidacao('interessado.pessoaFisica.orgaoExpedidor.obrigatorio')")
        el-select.input(
          name='Órgão expedidor',
          class="select",
          no-match-text="Nenhum orgão encontrado",
          placeholder="Selecione",
          v-model="interessadoOrgaoExpedidor.nome",
          value-key="id",
          filterable,
          clearable,
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="orgaoExpedidor in orgaosExpedidores",
            :key="orgaoExpedidor.id",
            :label="getName(orgaoExpedidor)",
            :value="orgaoExpedidor"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.orgaoExpedidor.validacao')", v-slot="{ errors }", :name="nomeAba + '/UF do RG do interessado'")
        app-label(label="UF do RG:", :required="camposValidacao('interessado.pessoaFisica.orgaoExpedidor.obrigatorio')")
        el-select.input(
          name='UF do RG'
          class="select",
          no-match-text="Nenhuma UF encontrada",
          placeholder="Selecione",
          v-model="interessadoOrgaoExpedidor.codigoEstado"
          clearable,
          filterable,
          :disabled="!interessadoOrgaoExpedidor.nome",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="estado in estadosBr",
            :key="estado.codigo",
            :label="estado.nome",
            :value="estado"
          )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      app-input-telefone(
        :telefones="cadastroFormulario.interessado.pessoa.telefones",
        :nomeAba="nomeAba",
        :requiredTelefones="true"
        :observer="observer"
      )
    el-col.inputDiv(:span="8")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.email.validacao')", v-slot="{ errors }", :name="nomeAba + '/E-mail do interessado'")
        app-label(:label="camposValidacao('interessado.pessoaFisica.email.label')")
        el-input.input(
          name="E-mail",
          v-model="cadastroFormulario.interessado.pessoa.email",
          maxlength="100"
          label='email',
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row.row
    el-col.coluna(:span="8")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.nacionalidade.validacao')", v-slot="{ errors }", :name="nomeAba + '/Nacionalidade do interessado'")
        app-label(:label="camposValidacao('interessado.pessoaFisica.nacionalidade.label')")
        el-select.input(
          name='Nacionalidade'
          class="select",
          no-match-text="Nenhuma nacionalidade encontrada",
          placeholder="Selecione",
          v-model="cadastroFormulario.interessado.pessoa.pessoaFisica.nacionalidade"
          value-key="id"
          clearable,
          filterable,
          :class="{'erro' : errors.length}"
        )
          el-option.selectNacionalidade(
            v-for="item in gentilico",
            :key="item.id",
            :label="item.gentilico +' - '+ item.nomePais",
            :value="item.sigla",
          )
        span.help.erro {{ errors[0] }}
    el-col.coluna(:span="8" v-if="naturalidadeInteressado")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.ufNaturalidade.validacao') && isBrasileiro ? 'required' : ''", v-slot="{ errors }", :name="nomeAba + '/UF de Naturalidade do interessado'")
        app-label(:label="camposValidacao('interessado.pessoaFisica.ufNaturalidade.label')", :required="isBrasileiro && camposValidacao('interessado.pessoaFisica.ufNaturalidade.obrigatorio')")
        el-select.input(
          class="select",
          no-match-text="Nenhuma UF encontrada",
          placeholder="Selecione",
          v-model="naturalidadeInteressado.codigoEstado",
          clearable,
          @change='setMunicipioUf',
          filterable,
          :disabled="!isBrasileiro",
          name="UF de naturalidade",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in estadosBr",
            :key="item.codigo",
            :label="item.nome",
            :value="item.codigo"
          )
        span.help.erro {{ errors[0] }}
    el-col.coluna-ultimo(:span="8" v-if="naturalidadeInteressado")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.ufNaturalidade.validacao') && isBrasileiro ? 'required' : ''", v-slot="{ errors }", :name="nomeAba + '/Município de Naturalidade do interessado'")
        app-label(label="Município de naturalidade:", :required="isBrasileiro && camposValidacao('interessado.pessoaFisica.ufNaturalidade.obrigatorio')")
        el-select.input(
          class="select",
          name='Município de Naturalidade'
          no-match-text="Nenhum município encontrado",
          placeholder="Selecione",
          v-model="naturalidadeInteressado.nome",
          filterable,
          :disabled="!isBrasileiro",
          :class="{'erro' : errors.length}"
          value-key="id"
        )
          el-option(
            v-for="item in municipiosNaturalidadeInteressado",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )
        span.help.erro {{ errors[0] }}
  el-row(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.estadoCivil.validacao')", v-slot="{ errors }", :name="nomeAba + '/Estado civil'")
        app-label(:label="camposValidacao('interessado.pessoaFisica.estadoCivil.label')", :required="camposValidacao('interessado.pessoaFisica.estadoCivil.obrigatorio')")
        el-select.input(
          class="select",
          name='Estado civil'
          v-model="cadastroFormulario.interessado.pessoa.pessoaFisica.estadoCivil",
          value-key="codigo"
          no-match-text="Nenhum estado civil encontrado",
          placeholder="Selecione",
          clearable,
          filterable,
          :class="{'erro' : errors.length}",
          @change="changeEstadoCivil"
        )
          el-option(
            v-for="item in estadosCivil",
            :key="item.codigo",
            :label="item.nome",
            :value="item.codigo"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(:rules="camposValidacao('interessado.pessoaFisica.dataNascimento.validacao')", v-slot="{ errors }", :name="nomeAba + '/Data de nascimento do interessado'")
        app-label(:label="camposValidacao('interessado.pessoaFisica.dataNascimento.label')", :required="camposValidacao('interessado.pessoaFisica.dataNascimentos.obrigatorio')")
        el-date-picker.input.full-width(
          type="date",
          name='Data de nascimento'
          v-model="cadastroFormulario.interessado.pessoa.pessoaFisica.dataNascimento",
          placeholder="Selecione",
          format="dd/MM/yyyy",
          v-mask="'##/##/#####'",
          :picker-options="pickerOptions",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  //- ABA Cônjuge CASADO, UNIÃO ESTÁVEL E UNIÃO HOMOAFETIVA
  div(v-if="hasConjuge && cadastroFormulario.interessado.pessoa.pessoaFisica.estadoCivil !== 'VIUVO'")
    app-divider(label="Cônjuge")
    el-row(:gutter="30")
      el-col(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.cpf.validacao')", v-slot="{ errors }", :name="nomeAba + '/CPF do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.cpf.label')")
          el-input.input(
            name='CPF',
            v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.cpf",
            v-mask="'###.###.###-##'",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
      el-col.inputDiv(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.nome.validacao')", v-slot="{ errors }", :name="nomeAba + '/Nome do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.nome.label')")
          el-input.input(
            name='Nome',
            maxlength="300",
            v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.nome",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
    el-row.labelDiv(:gutter="30")
      el-col(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.apelido.validacao')" v-slot="{ errors }", :name="nomeAba + '/Apelido do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.apelido.label')" :required="camposValidacao('conjuge.pessoaFisica.apelido.obrigatorio')")
          el-input.input(
            type="text"
            maxlength="300"
            name='apelido'
            v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.apelido"
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}

    el-row.labelDiv(:gutter="30")
      el-col.inputDiv(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.rg.validacao')", v-slot="{ errors }", :name="nomeAba + '/RG do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.rg.label')", :required="camposValidacao('conjuge.pessoaFisica.rg.obrigatorio')")
          el-input.input(
            name='RG',
            maxlength="30",
            v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.rg",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
      el-col.inputDiv(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.orgaoExpedidor.validacao')", v-slot="{ errors }", :name="nomeAba + '/Órgão Expedidor do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.orgaoExpedidor.label')", :required="camposValidacao('conjuge.pessoaFisica.orgaoExpedidor.obrigatorio')")
          el-select.input(
            name='Órgão expedidor',
            class="select",
            no-match-text="Nenhum orgão encontrado",
            placeholder="Selecione",
            v-model="conjugeOrgaoExpedidor.nome",
            value-key="id",
            filterable,
            clearable,
            :class="{'erro' : errors.length}"
          )
            el-option(
              v-for="orgaoExpedidor in orgaosExpedidores",
              :key="orgaoExpedidor.id",
              :label="getName(orgaoExpedidor)",
              :value="orgaoExpedidor"
            )
          span.help.erro {{ errors[0] }}
      el-col.inputDiv(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.rg.validacao')", v-slot="{ errors }", :name="nomeAba + '/UF do RG do cônjuge'")
          app-label(label="UF do RG:", :required="camposValidacao('conjuge.pessoaFisica.rg.obrigatorio')")
          el-select.input(
            name='UF do RG'
            class="select",
            no-match-text="Nenhuma UF encontrada",
            placeholder="Selecione",
            v-model="conjugeOrgaoExpedidor.codigoEstado"
            clearable,
            filterable,
            :disabled="!conjugeOrgaoExpedidor.nome",
            :class="{'erro' : errors.length}"
          )
            el-option(
              v-for="estado in estadosBr",
              :key="estado.codigo",
              :label="estado.nome",
              :value="estado"
            )
          span.help.erro {{ errors[0] }}
    el-row.labelDiv.row
      el-col.coluna(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.nacionalidade.validacao')", v-slot="{ errors }", :name="nomeAba + '/Nacionalidade do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.nacionalidade.label')")
          el-select.input(
            name='Nacionalidade'
            class="select",
            no-match-text="Nenhuma nacionalidade encontrada",
            placeholder="Selecione",
            v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.nacionalidade"
            value-key="id"
            clearable,
            filterable,
            :class="{'erro' : errors.length}"
          )
            el-option.selectNacionalidade(
              v-for="item in gentilico",
              :key="item.id",
              :label="item.gentilico +' - '+ item.nomePais",
              :value="item.sigla",
            )
          span.help.erro {{ errors[0] }}
      el-col.coluna(:span="8" v-if="naturalidadeConjuge")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.ufNaturalidade.validacao') && isBrasileiroConjuge ? 'required' : ''", v-slot="{ errors }", :name="nomeAba + '/UF de Naturalidade do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.ufNaturalidade.label')", :required="isBrasileiroConjuge && camposValidacao('conjuge.pessoaFisica.ufNaturalidade.obrigatorio')")
          el-select.input(
            class="select",
            no-match-text="Nenhuma UF encontrada",
            placeholder="Selecione",
            v-model="naturalidadeConjuge.codigoEstado",
            clearable,
            @change='setMunicipioUfConjuge',
            filterable,
            :disabled="!isBrasileiroConjuge",
            name="UF de naturalidade",
            :class="{'erro' : errors.length}"
          )
            el-option(
              v-for="item in estadosBr",
              :key="item.codigo",
              :label="item.nome",
              :value="item.codigo"
            )
          span.help.erro {{ errors[0] }}
      el-col.coluna-ultimo(:span="8" v-if="naturalidadeConjuge")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.ufNaturalidade.validacao') && isBrasileiroConjuge ? 'required' : ''", v-slot="{ errors }", :name="nomeAba + '/Município de Naturalidade do cônjuge'")
          app-label(label="Município de naturalidade:", :required="isBrasileiroConjuge && camposValidacao('conjuge.pessoaFisica.naturalidade.obrigatorio')")
          el-select.input(
            class="select",
            name='Município de Naturalidade'
            no-match-text="Nenhum município encontrado",
            placeholder="Selecione",
            v-model="naturalidadeConjuge.nome",
            filterable,
            :disabled="!isBrasileiroConjuge && !naturalidadeConjuge.codigoEstado",
            :class="{'erro' : errors.length}"
            value-key="id"
          )
            el-option(
              v-for="item in municipiosNaturalidadeConjuge",
              :key="item.id",
              :label="item.nome",
              :value="item"
            )
          span.help.erro {{ errors[0] }}
    el-row(:gutter="30")
      el-col.inputDiv(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.dataNascimento.validacao')", v-slot="{ errors }", :name="nomeAba + '/Data de nascimento do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.dataNascimento.label')", :required="camposValidacao('conjuge.pessoaFisica.dataNascimento.obrigatorio')")
          el-date-picker.input.full-width(
            type="date",
            name='Data de nascimento'
            v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.dataNascimento",
            placeholder="Selecione",
            format="dd/MM/yyyy",
            v-mask="'##/##/#####'",
            :picker-options="pickerOptions",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
  //- ABA Cônjuge VIUVO
  div(v-if="hasConjuge && cadastroFormulario.interessado.pessoa.pessoaFisica.estadoCivil === 'VIUVO'")
    app-divider(label="Cônjuge")
    el-row(:gutter="30")
      el-col(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.cpf.validacao')", v-slot="{ errors }", :name="nomeAba + '/CPF do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.cpf.label')", :required="camposValidacao('conjuge.pessoaFisica.cpf.obrigatorio')")
          el-input.input(
            name='CPF',
            v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.cpf",
            v-mask="'###.###.###-##'",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
      el-col.inputDiv(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.nome.validacao')", v-slot="{ errors }", :name="nomeAba + '/Nome do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.nome.label')", :required="camposValidacao('conjuge.pessoaFisica.nome.obrigatorio')")
          el-input.input(
            name='Nome',
            maxlength="300",
            v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.nome",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
    el-row.labelDiv(:gutter="30")
      el-col(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.apelido.validacao')" v-slot="{ errors }", :name="nomeAba + '/Apelido do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.apelido.label')" :required="camposValidacao('conjuge.pessoaFisica.apelido.obrigatorio')")
          el-input.input(
            type="text"
            maxlength="300"
            name='apelido'
            v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.apelido"
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
    el-row.inputDiv(:gutter="30")
      el-col.inputDiv(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.possuiCertidaoObito.validacao')", v-slot="{ errors }", :name="nomeAba + '/Possui certidão de óbito'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.possuiCertidaoObito.label')", :required="camposValidacao('conjuge.pessoaFisica.possuiCertidaoObito.obrigatorio')")
          el-radio.input(v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.temCertidaoObito" @change="changePossuiCertidaoObito", :label="true", :class="{'erro' : errors.length}") Sim
          el-radio.input(v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.temCertidaoObito", @change="changePossuiCertidaoObito" :label="false", :class="{'erro' : errors.length}") Não
          span.help.erro {{ errors[0] }}
    el-row(:gutter="30")
      el-col.inputDiv(:span="8")
        validation-provider(:rules="camposValidacao('conjuge.pessoaFisica.dataNascimento.validacao')", v-slot="{ errors }", :name="nomeAba + '/Data de nascimento do cônjuge'")
          app-label(:label="camposValidacao('conjuge.pessoaFisica.dataNascimento.label')", :required="true")
          el-date-picker.input.full-width(
            type="date",
            name='Data de nascimento'
            v-model="cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.dataNascimento",
            placeholder="Selecione",
            format="dd/MM/yyyy",
            v-mask="'##/##/#####'",
            :picker-options="pickerOptions",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}

</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import get from 'lodash/get'

import AppLabel from '@/components/AppLabel'
import estadosBr from '@/constants/estados'
import gentilico from '@/constants/gentilico'
import AppDadosConjuge from './AppDadosConjuge'
import AppInputTelefone from '@/components/AppInputTelefoneRetificacao'
const { estadosCivil } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasCentral').default
const { profissoes } = require('@/utils/ma/regrasCentral').default
const { campos } = require('@/screens/central/cadastros/para/retificacao/' +
  process.env.ESTADO +
  '/configuracaoPessoa').default

export default {
  components: {
    AppLabel,
    AppDadosConjuge,
    AppInputTelefone
  },

  props: {
    nomeAba: {
      type: String,
      required: true
    },
    observer: {
      required: true
    },
    isLiberacao: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      oldEstadoCod: '',
      orgaosExpedidores: [],
      estadosBr,
      gentilico,
      estadosCivil,
      profissoes,
      municipios: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      radio: null,
      telefones: [],
      municipiosConjuge: [],
      isUsarDadosCadastrante: false,
      cadastroFormulario: null,
      naturalidadeInteressado: null,
      naturalidadeConjuge: null,
      interessadoOrgaoExpedidor: {
        nome: '',
        codigoEstado: ''
      },
      conjugeOrgaoExpedidor: {
        nome: '',
        codigoEstado: ''
      },
      municipiosNaturalidadeInteressado: [],
      municipiosNaturalidadeConjuge: [],
      updateInteressadoEndereco: null,
      dadosCadastrante: null,
      tipoCadastro: null
    }
  },

  async created () {
    this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    this.naturalidadeInteressado = await this.getNaturalidadeById(this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.naturalidade?.municipio)
    this.naturalidadeConjuge = await this.getNaturalidadeById(this.cadastroFormulario?.interessado?.conjuge?.pessoa?.pessoaFisica?.naturalidade?.municipio)
    this.interessadoOrgaoExpedidor = await this.getOrgaoExpedidor(this.cadastroFormulario.interessado.pessoa.pessoaFisica.orgaoExpedidor)
    this.conjugeOrgaoExpedidor = await this.getOrgaoExpedidor(this.cadastroFormulario?.interessado?.conjuge?.pessoa?.pessoaFisica?.orgaoExpedidor)
    this.municipiosNaturalidadeInteressado = await this.getMunicipios(this.naturalidadeInteressado)
    this.municipiosNaturalidadeConjuge = await this.getMunicipios(this.naturalidadeConjuge.codigoEstado)
    this.dadosCadastrante = this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica.cpf === this.cadastroFormulario?.cadastrante?.pessoa?.pessoaFisica.cpf
    this.tipoCadastro = this.tipo.replace(/['"]/g, '')
  },

  activated () {
    this.telefones = this.cadastroFormulario?.interessado?.pessoa?.telefones
  },

  async mounted () {
    this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    if (this.isLiberacao) {
      this.profissoes = profissoes()
    }
    this.setOrgaosExpeditores()
    this.telefones = this.cadastroFormulario?.interessado?.pessoa?.telefones
  },

  computed: {
    ...mapGetters({
      cadastroJson: 'retificacao/cadastro',
      tipo: 'retificacao/tipo'
    }),

    isBrasileiro () {
      return (
        this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.nacionalidade &&
        this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.nacionalidade === 'BR'
      )
    },

    isBrasileiroConjuge () {
      return (
        this.cadastroFormulario?.interessado?.conjuge?.pessoa?.pessoaFisica?.nacionalidade &&
        this.cadastroFormulario?.interessado?.conjuge?.pessoa?.pessoaFisica?.nacionalidade === 'BR'
      )
    },

    pessoaFisica () {
      return this.cadastroFormulario.interessado.pessoa.pessoaFisica
    },

    hasConjuge () {
      return (
        this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.estadoCivil &&
        (this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.estadoCivil === 'CASADO' ||
          this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.estadoCivil === 'UNIAO_ESTAVEL' ||
          this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.estadoCivil === 'UNIAO_HOMOAFETIVA' ||
          this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.estadoCivil === 'VIUVO')
      )
    },
    isViuvo () {
      return this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.estadoCivil === 'VIUVO'
    }

  },

  methods: {
    ...mapActions('retificacao', ['update', 'updateObjeto', 'updateNacionalidade']),
    ...mapMutations(
      'retificacao', ['CHANGE_ESTADO_CIVIL', 'CHANGE_NACIONALIDADE', 'UPDATE_DADOS_CADASTRANTE']
    ),
    ...mapActions({
      getOrgaosExpedidores: 'orgaosExpedidores/getItems',
      getMunicipiosByUf: 'municipios/findMunicipiosByUf',
      getMunicipioById: 'municipios/findMunicipioById'
    }),

    getName (orgaoExpedidor) {
      return orgaoExpedidor.codigo === 'OUTROS'
        ? orgaoExpedidor.nome
        : `${orgaoExpedidor.codigo} - ${orgaoExpedidor.nome}`
    },

    async setOrgaosExpeditores () {
      this.orgaosExpedidores = await this.getOrgaosExpedidores()
    },

    showUsarDadosCadastrante () {
      return this.cadastroFormulario?.interessado && this.cadastroFormulario?.interessado?.pessoa?.isPessoaFisica &&
        this.cadastroFormulario.cadastrante.pessoa.isPessoaFisica && this.tipoCadastro === 'NAO_ONEROSO' &&
        this.cadastroFormulario.cadastrante.pessoa.pessoaFisica.cpf !== this.cadastroFormulario.interessado.pessoa.pessoaFisica.cpf
    },

    async getMunicipios (naturalidade) {
      return naturalidade?.codigoEstado ? this.getMunicipiosByUf(naturalidade.codigoEstado) : []
    },

    async getOrgaoExpedidor (orgaoExpedidor) {
      const orgaoExpedidores = await this.getOrgaosExpedidores()
      return orgaoExpedidor?.estado
        ? {
          codigoEstado: this.estadosBr
            .filter(item => item.codigo === orgaoExpedidor.estado)[0].nome,
          nome: orgaoExpedidores
            .filter(item => item.codigo === orgaoExpedidor.codigo)[0].nome
        }
        : {codigoEstado: '', nome: ''}
    },

    async changeEstado () {
      this.municipios = await this.getMunicipiosByUf(this.cadastroFormulario?.interessado?.pessoa.ufNaturalidade)
    },

    getNaturalidadeById (municipio) {
      return municipio && municipio.id
        ? this.getMunicipioById(municipio.id)
        : {
          codigoEstado: '',
          codigoMunicipio: '',
          id: '',
          idRegiao: '',
          mf: '',
          nome: '',
          nomeComCodigoEstadoFormatado: '',
          regiao: '',
          valorNivelMunicipio: '',
          valorReferencia: ''
        }
    },

    changeEstadoCivil () {
      this.$emit('changeEstadoCivil', this.cadastroFormulario?.interessado?.pessoa)
    },

    changePossuiCertidaoObito () {
      this.$emit('changePossuiCertidaoObito', this.cadastroFormulario?.interessado?.conjuge?.pessoa?.pessoaFisica?.temCertidaoObito)
    },

    async setMunicipioUf (sigla) {
      this.naturalidadeInteressado.codigoEstado = sigla
      this.naturalidadeInteressado.nome = ''
      this.municipiosNaturalidadeInteressado = await this.getMunicipiosByUf(sigla)
    },
    async setMunicipioUfConjuge (sigla) {
      this.naturalidadeConjuge.codigoEstado = sigla
      this.naturalidadeConjuge.nome = ''
      this.municipiosNaturalidadeConjuge = await this.getMunicipiosByUf(sigla)
    },

    findOrgaoExpedidorNameByCodigo () {
      this.cadastroFormulario.interessado.pessoa.pessoaFisica.orgaoExpedidor.nome = this.orgaosExpedidores.find(
        orgao => orgao.codigo === this.cadastroFormulario.interessado.pessoa.pessoaFisica.orgaoExpedidor.codigo
      ).nome
    },
    camposValidacao (campo) {
      const camposObj = campos(this.isViuvo)
      const valor = get(camposObj, campo)
      return valor
    },
    usarDadosCadastrante () {
      this.UPDATE_DADOS_CADASTRANTE(this.dadosCadastrante)
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      this.$emit('usarDadosCadastrante', this.dadosCadastrante)
    }
  },

  watch: {
    'cadastroFormulario.interessado.pessoa.pessoaFisica.estadoCivil' (val) {
      this.CHANGE_ESTADO_CIVIL(val)
      this.update({field: 'interessado.pessoa.pessoaFisica.estadoCivil', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    },
    'cadastroFormulario.interessado.pessoa.pessoaFisica.cpf' (val) {
      this.update({field: 'interessado.pessoa.pessoaFisica.cpf', value: val})
    },
    'cadastroFormulario.interessado.pessoa.pessoaFisica.nome' (val) {
      this.update({field: 'interessado.pessoa.pessoaFisica.nome', value: val})
    },
    'cadastroFormulario.interessado.pessoa.pessoaFisica.apelido' (val) {
      this.update({field: 'interessado.pessoa.pessoaFisica.apelido', value: val})
    },
    'cadastroFormulario.interessado.pessoa.pessoaFisica.rg' (val) {
      this.update({field: 'interessado.pessoa.pessoaFisica.rg', value: val})
    },
    'interessadoOrgaoExpedidor.codigoEstado' (val) {
      if (val.codigo) {
        this.update({field: 'interessado.pessoa.pessoaFisica.orgaoExpedidor.estado', value: val.codigo})
        this.interessadoOrgaoExpedidor.codigoEstado = val.nome
        this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      }
    },
    'interessadoOrgaoExpedidor.nome' (val) {
      this.update({field: 'interessado.pessoa.pessoaFisica.orgaoExpedidor.codigo', value: val.codigo})
    },
    'naturalidadeInteressado.nome' (val) {
      if (val && val.id) {
        this.naturalidadeInteressado.nome = val.nome
        this.update({field: 'interessado.pessoa.pessoaFisica.naturalidade.municipio.id', value: val.id})
        this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      }
    },
    'cadastroFormulario.interessado.pessoa.email' (val) {
      this.update({field: 'interessado.pessoa.email', value: val})
    },
    'cadastroFormulario.interessado.pessoa.pessoaFisica.nacionalidade' (val) {
      this.CHANGE_NACIONALIDADE({value: val, codigo: 'INTERESSADO'})
      this.update({field: 'interessado.pessoa.pessoaFisica.nacionalidade', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      this.naturalidadeInteressado = this.getNaturalidadeById(this.cadastroFormulario?.interessado?.pessoa?.pessoaFisica?.naturalidade?.municipio)
    },
    'cadastroFormulario.interessado.pessoa.pessoaFisica.dataNascimento' (val) {
      this.update({field: 'interessado.pessoa.pessoaFisica.dataNascimento', value: val})
    },
    // ALTERAÇÕES CONJUGE
    'cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.cpf' (val) {
      this.update({field: 'interessado.conjuge.pessoa.pessoaFisica.cpf', value: val})
    },
    'cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.nome' (val) {
      this.update({field: 'interessado.conjuge.pessoa.pessoaFisica.nome', value: val})
    },
    'cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.apelido' (val) {
      this.update({field: 'interessado.conjuge.pessoa.pessoaFisica.apelido', value: val})
    },
    'cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.rg' (val) {
      this.update({field: 'interessado.conjuge.pessoa.pessoaFisica.rg', value: val})
    },
    'naturalidadeConjuge.nome' (val) {
      if (val && val.id) {
        this.naturalidadeConjuge.nome = val.nome
        this.update({field: 'interessado.conjuge.pessoa.pessoaFisica.naturalidade.municipio.id', value: val.id})
        this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      }
    },
    'conjugeOrgaoExpedidor.codigoEstado' (val) {
      if (val.codigo) {
        this.update({field: 'interessado.conjuge.pessoa.pessoaFisica.orgaoExpedidor.estado', value: val.codigo})
        this.conjugeOrgaoExpedidor.codigoEstado = val.nome
        this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      }
    },
    'conjugeOrgaoExpedidor.nome' (val) {
      this.update({field: 'interessado.conjuge.pessoa.pessoaFisica.orgaoExpedidor.codigo', value: val.codigo})
    },
    'cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.nacionalidade' (val) {
      this.CHANGE_NACIONALIDADE({value: val, codigo: 'CONJUGE'})
      this.update({field: 'interessado.conjuge.pessoa.pessoaFisica.nacionalidade', value: val})
      this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
      this.naturalidadeConjuge = this.getNaturalidadeById(this.cadastroFormulario?.conjuge?.pessoa?.pessoaFisica?.naturalidade?.municipio)
    },
    'cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.dataNascimento' (val) {
      this.update({field: 'interessado.conjuge.pessoa.pessoaFisica.dataNascimento', value: val})
    },
    'cadastroFormulario.interessado.conjuge.pessoa.pessoaFisica.temCertidaoObito' (val) {
      this.update({field: 'interessado.conjuge.pessoa.pessoaFisica.temCertidaoObito', value: val})
    }
  }
}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.conjuge {
  margin-left: 15px;
}
.select {
  width: 100%;
}

.full-width {
  width: 100%;
}

.coluna {
  margin: 0 20px 0 0;
}

.row {
  display: flex;
  flex-direction: row;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 100%;
  }

  .selectNacionalidade {
    left: 210px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppPessoaFisicaRetificacao.vue